import { useEffect, useState } from "react";
import {
  CheckoutSuccessHeader,
  SuccessImg,
  ContinueButton,
} from "../../components/Checkout/CheckoutSuccessComponents";
import { useSearchParams, useNavigate, useLocation } from "react-router-dom";
import config from "../../config";
import { useCart } from "../../contexts/Cart/CartContext";
import { getCurrentlyLoggedInUser } from "../../CommonFunctions";
import apiClient from "../../services/apiClient";

const BASE_API = config.API_BASE_URL;

// Define styles object
const styles = {
  successContainer: {
    width: "100%",
    height: "100%",
    alignItems: "center", // Center items horizontally
  },
};

// React component
export const CheckoutSuccess = () => {
  const { state, dispatch } = useCart();
  const { cart, fundraiser_participant } = state;
  const [orderSaved, setOrderSaved] = useState(false);

  const DONATION_ID = config.DONATION_ITEM_ID;
  const BUYOUT_ID = config.BUYOUT_ITEM_ID;
  const squareOrderID = localStorage.getItem("squareOrderID") || null;

  useEffect(() => {
    const setOrderInfoToBackend = async () => {
      try {
        const shippingInfo = JSON.parse(
          localStorage.getItem("shippingInfo") || "null"
        );
        const shippingOption = localStorage.getItem("shippingOption") || null;

        const customerName = localStorage.getItem("customerName") || null;
        const customerEmail = localStorage.getItem("customerEmail") || null;
        const customerPhoneNumber =
          localStorage.getItem("customerPhoneNumber") || null;
        let user = null;
        try {
          user = await getCurrentlyLoggedInUser();
        } catch (error) {}
        if (
          !shippingInfo ||
          !shippingOption ||
          !cart ||
          !customerName ||
          !customerEmail ||
          cart.length === 0 ||
          orderSaved
        ) {
          // if we know there's missing info or the order has already been called
          // don't needlessly call it again
          return;
        }
        // Mark the order as already sent
        setOrderSaved(true);

        // remove data from localstorage before api call
        localStorage.removeItem("shippingInfo");
        localStorage.removeItem("shippingOption");
        localStorage.removeItem("squareOrderID");
        localStorage.removeItem("customerName");
        localStorage.removeItem("customerEmail");
        localStorage.removeItem("customerPhoneNumber");

        const response = await apiClient.post(
          `${BASE_API}checkout/success/save-order/square/`,
          {
            session_id: squareOrderID,
            customerName: customerName,
            customerEmail: customerEmail,
            customerPhoneNumber: customerPhoneNumber,
            cart: cart,
            shippingInfo: shippingInfo,
            shippingOption: shippingOption,
            user: user,
            participant: fundraiser_participant?.id,
            donation_sku: DONATION_ID,
            buyout_sku: BUYOUT_ID,
          }
        );

        // clear the cart only on success in case user accidentally navigated to this page
        dispatch({ type: "CLEAR_CART" });
      } catch (error) {
        console.error("Error trying to save order:", error);
      }
    };

    if (squareOrderID) {
      setOrderInfoToBackend();
    }
  }, [orderSaved]);

  useEffect(() => {
    document.title = "Checkout Success";
  }, []);

  return (
    <div style={styles.successContainer}>
      <CheckoutSuccessHeader />
      <SuccessImg />
      <ContinueButton
        participant_code={state.fundraiser_participant?.participant_code || ""}
      />
    </div>
  );
};
